module.exports = __webpack_public_path__ + "img/icon_user.2caaa5ee.png";